<template>
<div role="group" class="b-form-group form-group">
  <template v-for="item in formData.root">
    <div class="form-row mb-3">
      <div class="col-sm-12 mb-1 form-question" v-html="item.question">
      </div>
      <div class="col-sm-12">
        <label class="input-group-addon login-label form-answer">{{item.answers}}</label>
      </div>
    </div>
  </template>
</div>
</template>

<script>
export default
{
  name: 'FormPreview',
  props: ['formData'],
  data: function()
  {
    return {

    }
  },
  created()
  {
    var me = this;
  },
  methods:
  {

  },
  computed:
  {

  }
}
</script>